export const localTranslations = {
  en: {
    'global.noResults': 'No results',
    'aiAssistant.title': 'AI assistant',
    'aiAssistant.open': 'Open AI assistant',
    'aiAssistant.close': 'Close chat',
    'aiAssistant.example':
      'Create a new Sales employee named "John Doe" with a phone.',
    'aiAssistant.placeholder':
      'Describe what your phone system should do, for example: Create a new extension named "John Smith" with DDI 50.',
    'aiAssistant.thinking': 'Thinking …',
    'aiAssistant.working': 'Working on it …',
    'aiAssistant.nextStep': 'Figuring out the next step …',
    'aiAssistant.checking': 'Checking your phone system …',
    'aiAssistant.assembling': 'Putting the pieces together …',
    'aiAssistant.lookingUp': 'Looking up the details …',
    'aiAssistant.almostThere': 'Almost there …',
    'aiAssistant.consulting': 'Consulting the phone system …',
    'aiAssistant.calculating': 'Crunching the numbers …',
    'aiAssistant.reviewing': 'Reviewing your setup …',
    'aiAssistant.drafting': 'Drafting the next action …',
    'aiAssistant.connecting': 'Connecting the dots …',
    'aiAssistant.done': 'Done.',
    'aiAssistant.unknownError': 'Unknown error.',
    'aiAssistant.connectionFailed': 'Connection failed.',
    'aiAssistant.serverError': 'AI demo server responded with {status}.',
  },
  de: {
    'global.noResults': 'Keine Ergebnisse',
    'aiAssistant.title': 'AI-Assistent',
    'aiAssistant.open': 'AI-Assistent öffnen',
    'aiAssistant.close': 'Chat schließen',
    'aiAssistant.example':
      'Erstelle einen neuen Mitarbeiter "John Doe" im Vertrieb mit einem Telefon.',
    'aiAssistant.placeholder':
      'Beschreibe, was deine Telefonanlage tun soll, z. B.: Erstelle eine neue Nebenstelle "John Smith" mit Durchwahl 50.',
    'aiAssistant.thinking': 'Ich denke nach …',
    'aiAssistant.working': 'Ich arbeite daran …',
    'aiAssistant.nextStep': 'Ich plane den nächsten Schritt …',
    'aiAssistant.checking': 'Ich prüfe deine Telefonanlage …',
    'aiAssistant.assembling': 'Ich füge alles zusammen …',
    'aiAssistant.lookingUp': 'Ich suche die Details …',
    'aiAssistant.almostThere': 'Fast geschafft …',
    'aiAssistant.consulting': 'Ich frage die Telefonanlage ab …',
    'aiAssistant.calculating': 'Ich rechne nach …',
    'aiAssistant.reviewing': 'Ich prüfe deine Konfiguration …',
    'aiAssistant.drafting': 'Ich bereite den nächsten Schritt vor …',
    'aiAssistant.connecting': 'Ich verknüpfe die Informationen …',
    'aiAssistant.done': 'Erledigt.',
    'aiAssistant.unknownError': 'Unbekannter Fehler.',
    'aiAssistant.connectionFailed': 'Verbindung fehlgeschlagen.',
    'aiAssistant.serverError':
      'Der AI-Server hat mit Status {status} geantwortet.',
  },
  fr: {
    'global.noResults': 'Aucun résultat',
    'aiAssistant.title': 'Assistant IA',
    'aiAssistant.open': "Ouvrir l'assistant IA",
    'aiAssistant.close': 'Fermer la discussion',
    'aiAssistant.example':
      'Crée un nouvel employé commercial nommé « John Doe » avec un téléphone.',
    'aiAssistant.placeholder':
      'Décris ce que ton système téléphonique doit faire, par exemple : crée un nouveau poste « John Smith » avec le numéro 50.',
    'aiAssistant.thinking': 'Je réfléchis …',
    'aiAssistant.working': "J'y travaille …",
    'aiAssistant.nextStep': 'Je cherche la prochaine étape …',
    'aiAssistant.checking': 'Je vérifie ton système téléphonique …',
    'aiAssistant.assembling': 'Je rassemble les informations …',
    'aiAssistant.lookingUp': 'Je recherche les détails …',
    'aiAssistant.almostThere': 'Presque terminé …',
    'aiAssistant.consulting': 'Je consulte le système téléphonique …',
    'aiAssistant.calculating': 'Je fais le calcul …',
    'aiAssistant.reviewing': 'Je vérifie ta configuration …',
    'aiAssistant.drafting': 'Je prépare la prochaine action …',
    'aiAssistant.connecting': 'Je relie les informations …',
    'aiAssistant.done': 'Terminé.',
    'aiAssistant.unknownError': 'Erreur inconnue.',
    'aiAssistant.connectionFailed': 'Échec de la connexion.',
    'aiAssistant.serverError':
      'Le serveur IA a répondu avec le statut {status}.',
  },
  nl: {
    'global.noResults': 'Geen resultaten',
    'aiAssistant.title': 'AI-assistent',
    'aiAssistant.open': 'AI-assistent openen',
    'aiAssistant.close': 'Chat sluiten',
    'aiAssistant.example':
      'Maak een nieuwe salesmedewerker met de naam "John Doe" en een telefoon aan.',
    'aiAssistant.placeholder':
      'Beschrijf wat je telefooncentrale moet doen, bijvoorbeeld: maak een nieuw toestel "John Smith" met doorkiesnummer 50 aan.',
    'aiAssistant.thinking': 'Ik denk na …',
    'aiAssistant.working': 'Ik werk eraan …',
    'aiAssistant.nextStep': 'Ik bepaal de volgende stap …',
    'aiAssistant.checking': 'Ik controleer je telefooncentrale …',
    'aiAssistant.assembling': 'Ik breng alles samen …',
    'aiAssistant.lookingUp': 'Ik zoek de details op …',
    'aiAssistant.almostThere': 'Bijna klaar …',
    'aiAssistant.consulting': 'Ik raadpleeg de telefooncentrale …',
    'aiAssistant.calculating': 'Ik reken het uit …',
    'aiAssistant.reviewing': 'Ik controleer je instellingen …',
    'aiAssistant.drafting': 'Ik bereid de volgende actie voor …',
    'aiAssistant.connecting': 'Ik verbind de informatie …',
    'aiAssistant.done': 'Klaar.',
    'aiAssistant.unknownError': 'Onbekende fout.',
    'aiAssistant.connectionFailed': 'Verbinding mislukt.',
    'aiAssistant.serverError': 'De AI-server antwoordde met status {status}.',
  },
}
